import {AnimationBaseController, IAnimationControllerConfiguration, Inject} from "@denishussar/html5-game-engine";
import {AnimationContents} from "../AnimationContents";
import {GameLogic} from "../../Logic/GameLogic";
import {GameModel} from "../../Models/GameModel";
import {ButtonController, IButtonControllerOptions} from "../Common/ButtonController";
import {SoundConstants} from "../../Constants/SoundConstants";
import {SoundType} from "@denishussar/html5-game-engine";

export class GameEndController extends AnimationBaseController {
    $model: GameModel;

    public constructor(@Inject private _options,
                       @Inject private _gameLogic: GameLogic) {
        super("GameEndController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.INTRO_SCREEN_JSON,
            libraryName: "game_end_container",
            childControllers:{
                OkButton: {
                    instanceName: "game_end.ok_button",
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () =>{
                            this._gameLogic.hideGameEnd();
                        },
                        hotKey: "SPACE"
                    }
                }
            },
            modelWatch: {
                "showGameEnd":async (showGameEnd:boolean) => {
                    this.visible = showGameEnd;
                    if(showGameEnd){
                        this.gotoAndPlay("show");


                        this.$sounds.get(SoundConstants.GAME_END).play();
                    } else {
                        this.$childControllers.get<ButtonController>("OkButton").disabled();
                    }
                },
            },
            sounds: [
                {
                    id: SoundConstants.GAME_END,
                    type: SoundType.SFX
                }
            ],
            queue: {
                "playGameEndMusic": {
                    condition: (clock: number) => {
                        return clock > 1;
                    },
                    action: (clock: number, data?: any) => {
                        this.$childControllers.get<ButtonController>("OkButton").enabled();

                    }
                }
            }
        };
    }

    protected onInitialize(): void {

        this.$childControllers.get<ButtonController>("OkButton").disabled();

        this.setTextByQuery("game_end.you_score_title", `${"YOU_SCORE"}:`);
        this.setTextByQuery("game_end.you_new_record_title", `${"NEW_RECORD"}:`);

        this.gotoAndStopByQuery("game_end", "new_record");
        this.gotoAndStopByQuery("game_end.game_end_rays", "idle");

        this.visible = this.$model.showGameEnd;
    }

    protected onResize(width: number, height: number, scale: number): void {
    }

}

